module.exports = __webpack_public_path__ + "static/media/promo-travel.bcdb236b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-travel.jpg
// module id = 322
// module chunks = 0